import { createContext } from 'react';
import { useFiltersContext } from '../../../../Common/Filters/hooks/useFiltersContext';
import { QUERY_KEYS_SIH, useChartsData } from '../../../../Common/hooks/useChartsData';


export const ServicesChartsDataContext = createContext();

const ServicesChartsDataProvider = ({ children , module }) => {
    const { filters } = useFiltersContext();
    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_SIH.TOTALS_HOSPITALIZATION,
            url: 'governanceroom/dashboard/sihsus/aih/hospitalizationTotals'
        },
        {
            location: filters.unidade.value,
            year: filters.ano?.value,
            month: filters.competencia?.value,
            city: filters.cidade?.value
        }
    );

    const chartData = data
        ? {
              counterServices: [
                  {
                      total_permanences: data.counterServices[0] ? data.counterServices[0].total_permanences : 0,
                      total_acommodations: data.counterServices[0] ? data.counterServices[0].total_acommodations : 0
                  }
              ],
              counterYear : data.counterYear ? data.counterYear : [],
              selectedYear : data.selectedYear ? data.selectedYear : []
          }
        : {
                counterServices: [
                    {
                        total_permanences: 0,
                        total_acommodations: 0
                    }
                ],
                counterYear: [],
                selectedYear: []
          };

    const colors = ['#1F77B4', '#FF7F0E'];

    const subtitles = ["Acomodações", "Permanências"];

    return (
        <ServicesChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                module,
                colors,
                subtitles,
                data
            }}
        >
            {children}
        </ServicesChartsDataContext.Provider>
    );
};

export default ServicesChartsDataProvider;
